import { forwardRef } from 'react';

interface AfricaTownLogoProps {
  className?: string;
  iconColor?: string;
  buildingsColor?: string;
  textColor?: string;
}

export const AfricaTownLogo = forwardRef<SVGSVGElement, AfricaTownLogoProps>(
  ({
    className = '',
    iconColor = 'currentColor',
    buildingsColor = 'currentColor',
    textColor = 'currentColor'
  }, ref) => {
    return (
      <svg
        ref={ref}
        className={className}
        viewBox="0 0 343.70667 217.09332"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="pin-icon" className="pin-icon">
          <path
            id="pointer"
            className="pointer"
            fill={iconColor}
            d="m 1125.55,1092.78 c 0.03,-0.15 0.07,-0.32 0.13,-0.46 4.59,-11.18 10.25,-22.11 16.74,-32.49 0.27,-0.45 0.5,-0.94 0.8,-1.38 l 184.34,-357.927 184.3,357.967 c 0.25,0.45 0.5,0.89 0.78,1.43 6.5,10.29 12.09,21.17 16.73,32.4 0.11,0.23 0.18,0.46 0.24,0.68 10.74,26.23 16.21,53.97 16.21,82.54 0,120.35 -97.93,218.24 -218.26,218.24 -120.42,0 -218.32,-97.89 -218.32,-218.24 0,-28.64 5.48,-56.5 16.31,-82.76 z m 202.01,-454.522 c -7.36,0 -14.06,4.082 -17.4,10.566 L 1108.8,1039.78 c -7.43,11.93 -13.87,24.51 -19.24,37.46 -0.07,0.14 -0.11,0.27 -0.14,0.4 v 0 c -12.8,31.11 -19.35,64 -19.35,97.9 0,141.94 115.5,257.42 257.49,257.42 141.93,0 257.44,-115.48 257.44,-257.42 0,-33.48 -6.41,-66.12 -18.96,-96.96 -0.26,-0.72 -0.49,-1.4 -0.86,-2.08 -5.32,-12.62 -11.63,-25.02 -18.89,-36.67 L 1344.96,648.824 c -3.4,-6.484 -10.14,-10.566 -17.4,-10.566 v 0"
            transform="matrix(0.13333333,0,0,-0.13333333,0,217.09333)"
          />
          <path
            id="africa"
            className="africa"
            fill={iconColor}
            d="m 1475.6,1179 -5.21,-2.99 5.21,2.99 m -168.46,-106.7 3.62,2.36 -4.35,17.89 -13.85,15.98 1.82,29.26 -2.06,3.12 -14.81,0.56 -2.93,2.37 -0.9,2.54 -3.5,3.42 -11.57,-0.57 -1.49,-0.98 0.97,-1.65 1.64,-1.21 -46.88,-5.04 -9.5,10.22 -6.02,1.47 -23.94,36.71 4.35,9.07 3.01,45.7 14.97,16.22 0.23,1.76 8.27,5.12 4.83,8.16 1.47,9.69 13.06,10.61 0.76,1.72 5.85,3.25 17.66,1.56 0.6,0.92 5.32,3.6 44.51,1.71 -1.69,-5.81 2.98,-0.42 -0.48,-4.79 -1.8,-0.72 -3.27,-4.8 10.47,-5.54 12.96,-0.42 1.94,-2.16 -0.23,-4.52 2.7,-2.59 13.43,-3.34 1.01,2.54 -1.44,7.19 3.56,3.9 11.85,-1.24 7.43,-5.01 31.07,-1.67 2.91,-8.02 7.4,-7.38 6.04,-17.86 11.67,-13.89 1.51,-11.64 18.88,-28.66 4.85,-3.08 5.26,-13.22 1.73,-0.89 18.64,1.56 11.1,5.62 2.91,-4.02 -20.6,-49.03 -29.9,-29.07 -1.02,-0.47 -4.02,-5.53 10.21,-49.35 -27.99,-24.52 -0.09,-1.6 1.28,-2.45 0.45,-14.42 -4.42,-6.625 -1.57,-0.719 -5.76,-9.125 -0.84,-8.406 -36.85,-32.075 -14.12,0.317 -2.31,-1.918 -7.01,-2.43 -2.83,1.102 -5.37,5.578 -0.94,15.336 -8.91,10.297 -15.77,66.388 9.93,17.4 0.06,5.03 -6.14,11.63"
            transform="matrix(0.13333333,0,0,-0.13333333,0,217.09333)"
          />
          <path
            id="spark-r"
            className="spark spark-r"
            fill={iconColor}
            d="m 1607.52,1306.96 c -5.96,0 -11.95,2.29 -16.48,6.85 -9.15,9.13 -9.15,23.89 0,33 l 68.57,68.6 c 9.14,9.12 23.93,9.12 33.02,0 9.11,-9.12 9.11,-23.89 0,-33.03 l -68.61,-68.57 c -4.55,-4.56 -10.5,-6.85 -16.5,-6.85 v 0"
            transform="matrix(0.13333333,0,0,-0.13333333,0,217.09333)"
          />
          <path
            id="spark-m"
            className="spark spark-m"
            fill={iconColor}
            d="m 1323.65,1484.46 c -12.93,0 -23.36,10.44 -23.36,23.39 v 97 c 0,12.91 10.43,23.34 23.36,23.34 12.88,0 23.33,-10.43 23.33,-23.34 v -97 c 0,-12.95 -10.45,-23.39 -23.33,-23.39 v 0"
            transform="matrix(0.13333333,0,0,-0.13333333,0,217.09333)"
          />
          <path
            id="spark-l"
            className="spark spark-l"
            fill={iconColor}
            d="m 1047.5,1306.96 c -5.99,0 -11.97,2.29 -16.54,6.85 l -68.562,68.57 c -9.105,9.14 -9.105,23.91 0,33.03 9.141,9.12 23.926,9.12 33.028,0 l 68.564,-68.6 c 9.11,-9.11 9.11,-23.87 0,-33 -4.57,-4.56 -10.56,-6.85 -16.49,-6.85 v 0"
            transform="matrix(0.13333333,0,0,-0.13333333,0,217.09333)"
          />
        </g>

        <path
          id="buildings"
          className="buildings"
          fill={buildingsColor}
          d="M 681.40138 871.69609 L 681.40138 822.60918 L 633.29591 822.60918 L 633.29591 630.5828 L 444.15528 689.99687 L 254.97071 630.5828 L 254.97071 412.74588 L 121.875 412.74588 L 121.875 376.95975 L 2454.6973 376.95975 L 2454.6973 412.74588 L 2318.5547 412.74588 L 2318.5547 703.75175 L 2272.8663 703.75175 L 2272.8663 722.73613 L 2018.1739 798.87871 L 1839.5215 745.4705 L 1839.5215 789.5916 L 1811.0157 789.5916 L 1811.0157 736.91581 L 1763.5547 722.73613 L 1763.5547 703.75175 L 1712.212 703.75175 L 1712.212 578.97636 L 1646.2354 578.97636 L 1646.2354 610.67558 L 1024.5117 610.67558 L 1024.5117 822.60918 L 896.10354 822.60918 L 896.10354 871.69609 L 681.40138 871.69609 z M 681.40138 765.69999 L 718.38869 765.69999 L 718.38869 702.3748 L 681.40138 702.3748 L 681.40138 765.69999 z M 941.10354 765.69999 L 978.09084 765.69999 L 978.09084 702.3748 L 941.10354 702.3748 L 941.10354 765.69999 z M 681.32814 658.34159 L 718.44728 658.34159 L 718.44728 595.0164 L 681.32814 595.0164 L 681.32814 658.34159 z M 1874.8536 645.158 L 1911.9288 645.158 L 1911.9288 591.55936 L 1874.8536 591.55936 L 1874.8536 645.158 z M 2047.9834 645.158 L 2085.0147 645.158 L 2085.0147 591.55936 L 2047.9834 591.55936 L 2047.9834 645.158 z M 681.47463 555.11405 L 718.3301 555.11405 L 718.3301 491.74491 L 681.47463 491.74491 L 681.47463 555.11405 z M 2134.6143 553.29765 L 2171.6602 553.29765 L 2171.6602 499.65507 L 2134.6143 499.65507 L 2134.6143 553.29765 z M 2221.2159 553.29765 L 2258.1446 553.29765 L 2258.1446 499.65507 L 2221.2159 499.65507 L 2221.2159 553.29765 z M 423.33985 524.77714 L 477.14357 524.77714 L 477.14357 425.53397 L 423.33985 425.53397 L 423.33985 524.77714 z M 992.6221 514.08378 L 1172.3731 514.08378 L 1172.3731 475.17753 L 992.6221 475.17753 L 992.6221 514.08378 z M 1646.2354 514.08378 L 1677.334 514.08378 L 1677.334 475.17753 L 1646.2354 475.17753 L 1646.2354 514.08378 z M 1716.6651 514.08378 L 1747.7637 514.08378 L 1747.7637 475.17753 L 1716.6651 475.17753 L 1716.6651 514.08378 z "
          transform="matrix(0.13333333,0,0,-0.13333333,0,217.09333)"
        />

        <g id="copy" className="copy text-logo">
          <path
            id="letter-n"
            className="letter"
            fill={textColor}
            d="M 2391.5,192.281 V 12.7813 h -46.29 V 305.191 l 185.94,-192.32 V 292.02 h 46.68 V 0 L 2391.5,192.281"
            transform="matrix(0.13333333,0,0,-0.13333333,0,217.09333)"
          />
          <path
            id="letter-w"
            className="letter"
            fill={textColor}
            d="M 2170.49,0.351563 2092.29,168.59 2018.86,0.351563 1883.2,292.02 h 51.06 l 83.4,-184.02 49.08,115.898 23.93,57.59 25.93,-56.84 52.69,-116.648 77.8,184.02 h 50.68 L 2170.49,0.351563"
            transform="matrix(0.13333333,0,0,-0.13333333,0,217.09333)"
          />
          <path
            id="letter-o"
            className="letter"
            fill={textColor}
            d="m 1660.16,220.148 c -19.16,-18.066 -29.93,-42.168 -29.93,-67.757 0,-25.582 10.77,-49.661 29.93,-67.7308 19.16,-18.0586 44.68,-28.2188 71.82,-28.2188 27.14,0 52.69,10.1602 71.83,28.2188 19.16,18.0698 29.94,42.1488 29.94,67.7308 0,25.589 -10.78,49.691 -29.94,67.757 -19.14,18.071 -44.69,28.231 -71.83,28.231 -27.14,0 -52.66,-10.16 -71.82,-28.231 z M 1674.53,23.6797 C 1656.57,30.8516 1641,41 1627.44,53.8086 c -13.55,12.793 -24.33,27.4805 -31.9,44.4102 -7.6,16.9102 -11.58,35.3712 -11.58,54.1722 0,18.839 3.98,37.281 11.58,54.578 7.57,16.562 18.35,31.25 31.9,44.422 13.56,12.789 29.13,22.578 47.09,29.738 17.97,7.141 37.52,10.891 57.45,10.891 19.94,0 39.5,-3.75 57.87,-10.891 17.55,-7.16 33.12,-16.949 47.07,-29.738 13.59,-13.172 23.95,-27.86 31.53,-44.422 7.59,-17.297 11.57,-35.739 11.57,-54.578 0,-18.801 -3.98,-37.262 -11.57,-54.1722 -7.58,-16.9297 -17.94,-31.6172 -31.53,-44.4102 C 1822.97,41 1807.4,30.8516 1789.85,23.6797 c -18.37,-7.1289 -37.93,-10.8984 -57.87,-10.8984 -19.93,0 -39.48,3.7695 -57.45,10.8984"
            transform="matrix(0.13333333,0,0,-0.13333333,0,217.09333)"
          />
          <path
            id="letter-t"
            className="letter"
            fill={textColor}
            d="m 1576.01,252.891 h -81.42 V 12.7813 h -46.66 V 252.891 h -81.43 v 39.129 h 209.51 v -39.129"
            transform="matrix(0.13333333,0,0,-0.13333333,0,217.09333)"
          />
          <path
            id="letter-a1"
            className="letter"
            fill={textColor}
            d="m 1292.71,111.762 -35.92,85.047 -35.89,-85.047 z m 16.78,-39.1526 H 1204.13 L 1179,12.7813 h -51.08 L 1256.79,304.82 1385.28,12.7813 h -50.67 l -25.12,59.8281"
            transform="matrix(0.13333333,0,0,-0.13333333,0,217.09333)"
          />
          <path
            id="letter-c"
            className="letter"
            fill={textColor}
            d="m 1099.61,35.7383 c -7.58,-4.5274 -15.55,-8.6563 -23.95,-12.0586 -18.35,-7.1289 -37.88,-10.8984 -57.85,-10.8984 -19.943,0 -39.509,3.7695 -57.455,10.8984 C 942.41,30.8516 926.84,41 913.266,53.8086 c -13.559,12.793 -24.321,27.4805 -31.922,44.4102 -7.571,16.9102 -11.547,35.3712 -11.547,54.1722 0,18.839 3.976,37.281 11.547,54.578 7.601,16.562 18.363,31.621 31.922,44.422 13.574,12.789 29.144,22.949 47.089,29.738 17.946,7.512 37.512,10.891 57.455,10.891 19.97,0 39.5,-3.379 57.85,-10.891 2.01,-0.758 4.38,-1.899 6.4,-2.66 v -51.547 c -17.95,13.93 -40.3,21.457 -64.25,21.457 -27.122,0 -52.669,-9.789 -71.818,-28.231 -19.152,-18.066 -29.933,-42.168 -29.933,-67.757 0,-25.582 10.781,-49.661 29.933,-67.7308 19.149,-18.0586 44.696,-28.2188 71.818,-28.2188 27.14,0 52.66,10.1602 71.81,28.2188 3.62,3.3789 6.8,6.7812 9.99,10.5312 V 35.7383"
            transform="matrix(0.13333333,0,0,-0.13333333,0,217.09333)"
          />
          <path
            id="letter-i"
            className="letter"
            fill={textColor}
            d="M 774.441,12.7813 V 292.02 h 46.274 V 12.7813 h -46.274"
            transform="matrix(0.13333333,0,0,-0.13333333,0,217.09333)"
          />
          <path
            id="letter-r"
            className="letter"
            fill={textColor}
            d="m 618.828,146.379 c 19.152,0 33.512,5.262 42.688,15.051 11.179,11.3 13.172,27.101 13.172,38.019 0,11.281 -1.993,27.102 -13.172,38.379 -9.176,9.801 -23.536,14.692 -42.688,14.692 H 577.324 V 146.379 Z M 738.113,12.7813 H 685.855 L 611.238,107.238 H 577.324 V 12.7813 H 531.039 V 292.02 h 39.106 48.683 c 39.106,0 61.836,-15.051 73.817,-27.84 15.554,-16.168 23.949,-38.77 23.949,-64.731 0,-25.597 -8.395,-48.16 -23.949,-64.371 -7.192,-7.508 -18.364,-16.168 -34.309,-21.457 L 738.113,12.7813"
            transform="matrix(0.13333333,0,0,-0.13333333,0,217.09333)"
          />
          <path
            id="letter-f"
            className="letter"
            fill={textColor}
            d="m 344.727,178.379 h 108.14 V 138.84 H 344.727 V 12.7813 H 298.438 V 292.02 h 45.886 132.078 V 252.891 H 344.727 v -74.512"
            transform="matrix(0.13333333,0,0,-0.13333333,0,217.09333)"
          />
          <path
            id="letter-a2"
            className="letter"
            fill={textColor}
            d="M 164.805,111.762 128.883,196.809 92.9727,111.762 Z M 181.543,72.6094 H 76.2148 L 51.0703,12.7813 H 0 L 128.883,304.82 257.379,12.7813 h -50.691 l -25.145,59.8281"
            transform="matrix(0.13333333,0,0,-0.13333333,0,217.09333)"
          />
        </g>
      </svg>
    );
  }
);

AfricaTownLogo.displayName = 'AfricaTownLogo';
